<script>
import { chartHelpers } from "./Charts";
import { Line } from 'vue-chartjs';
import dataLineChart from "./data/linechart.json";

export default {
  extends: Line,
  data() {
    return {
      cData: this.data
    }
  },
  computed: {
    mergedData: function () {
      return chartHelpers.mergeColorsIntoData(this.cData);
    }
  },
  props: {
    data: {
      type: Object,
      default() { 
        return dataLineChart
      }
    },
    options: {
      type: Object,
      default() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: {display:false, position: 'bottom', padding: 10, labels: {usePointStyle: true}},
          title: {display:false, text:'User Activity (in Thousands)'},
          elements: {
            point: {
              radius: 1
            }
          },
          scales: {
            yAxes: [{
              display: true,
              ticks: {
                beginAtZero: false,
                stepValue: 50,
                maxTicksLimit: 6
              }
            }]
          }
        };
      }
    },
    colors: {
      type: Array,
      default() { return ["#cfcfcf","#eaeaea","#dfdfdf"] }
    }
  },
  mounted() {
    this.renderChart(this.mergedData, this.options);
  }
};
</script>
